import React, { Component } from 'react';

import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import '../../ComplianceRule.css';

class RelatedCompPriceReportGrid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      columnDefs: props.relatedCompPriceReportGridColumns,
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 100,
        sortable: true,
        filter: true,
        resizable: true,
      },
      rowSelection: "multiple",
      popupParent: document.popupParent,
    };
  }

  getRowNodeId = data => {
    return data.id;
  };

  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    // const COLUMNS_KEY = 'fund-list-grid-col-state';

    // StateSynchronizer.syncGrid(
    //   params,
    //   this.state.columnDefs,
    //   () => localStorageClient.getGridColumnState(COLUMNS_KEY),
    //   s => localStorageClient.saveGridColumnState(COLUMNS_KEY, s)
    // );
  };

  render() {
    const {
      relatedCompanyPriceReportArray,
      className = 'grid-wrapper',
      // Load Related Company Price Report
      loadRelatedCompanyPriceReportActionStatus,
    } = this.props;

    const isLoading = loadRelatedCompanyPriceReportActionStatus === ACTION_STATUS.LOGINING;
    if (loadRelatedCompanyPriceReportActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadRelatedCompanyPriceReportActionStatus();
    }

    return (
      <div className={`ag-theme-balham ${className}`}>
        {isLoading ? (
          <Loader active content="Loading..." />
        ) : (
          <AgGridReact
            // properties
            columnDefs={this.state.columnDefs}
            rowData={relatedCompanyPriceReportArray}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            animateRows={true}
            immutableData={false}
            popupParent={this.state.popupParent}
            enableCharts={true}
            enableRangeSelection={true}
            getRowNodeId={this.getRowNodeId}
            // events
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
          />
        )}
        <div id="myChart" className="ag-theme-alpine my-chart"></div>
      </div>
    );
  }
}

export default RelatedCompPriceReportGrid;